const LOGO_ASSET_VERSION =
  process.env.REACT_APP_LOGO_ASSET_VERSION || process.env.REACT_APP_STATIC_MAP_MARKER_ICON_VERSION || '';

const APP_LOGO_ASSET_PATH_PATTERN = /^\/tph-logo-(mobile|desktop)\.(avif|webp|png)$/i;

export const withLogoAssetVersion = (assetPath = '') => {
  const normalizedAssetPath = String(assetPath || '').trim();
  if (!normalizedAssetPath || !LOGO_ASSET_VERSION) return normalizedAssetPath;

  const [pathWithQuery, hashFragment = ''] = normalizedAssetPath.split('#');
  const [pathname, existingQuery = ''] = pathWithQuery.split('?');

  if (!APP_LOGO_ASSET_PATH_PATTERN.test(pathname)) {
    return normalizedAssetPath;
  }

  const params = new URLSearchParams(existingQuery);
  params.set('v', LOGO_ASSET_VERSION);
  const nextQuery = params.toString();

  return `${pathname}${nextQuery ? `?${nextQuery}` : ''}${hashFragment ? `#${hashFragment}` : ''}`;
};

export const APP_LOGO_SOURCES = {
  mobile: {
    avif: withLogoAssetVersion('/tph-logo-mobile.avif'),
    webp: withLogoAssetVersion('/tph-logo-mobile.webp'),
  },
  desktop: {
    avif: withLogoAssetVersion('/tph-logo-desktop.avif'),
    webp: withLogoAssetVersion('/tph-logo-desktop.webp'),
  },
  fallback: withLogoAssetVersion('/tph-logo-desktop.webp'),
};
